// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fbbtpebhhglqkcexruob.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZiYnRwZWJoaGdscWtjZXhydW9iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzEwNzE2NzYsImV4cCI6MjA0NjY0NzY3Nn0.RAPz_fTOUwSiIkqbCpAap0zU8EiLJWk6CwvHZt-6p2Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});